module.exports = __webpack_public_path__ + "static/img/7.a391693.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/zh/7.png
// module id = Gg8+
// module chunks = 0